var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResultFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_21_x2C__Browser_x2C__internet_x2C__online_x2C__webpage",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.195,
    height: 74.195,
    viewBox: "0 0 74.195 74.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_408_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_437_",
    d: "M72.711,14.839H1.484A1.484,1.484,0,0,1,0,13.355V1.484A1.484,1.484,0,0,1,1.484,0H72.711A1.484,1.484,0,0,1,74.2,1.484V13.355A1.484,1.484,0,0,1,72.711,14.839ZM2.968,11.871h68.26v-8.9H2.968Z",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_",
    transform: "translate(0 11.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    d: "M72.711,142.324H1.484A1.484,1.484,0,0,1,0,140.84V81.484A1.484,1.484,0,0,1,1.484,80H72.711A1.484,1.484,0,0,1,74.2,81.484V140.84A1.484,1.484,0,0,1,72.711,142.324ZM2.968,139.356h68.26V82.968H2.968Z",
    transform: "translate(0 -80)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_430_",
    transform: "translate(17.807 5.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    d: "M120,40h2.968v2.968H120Z",
    transform: "translate(-120 -40)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_428_",
    transform: "translate(11.871 5.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    d: "M80,40h2.968v2.968H80Z",
    transform: "translate(-80 -40)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_426_",
    transform: "translate(5.936 5.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    d: "M40,40h2.968v2.968H40Z",
    transform: "translate(-40 -40)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_424_",
    transform: "translate(8.903 47.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    d: "M106,322.968H61.484a1.484,1.484,0,0,1,0-2.968H106a1.484,1.484,0,0,1,0,2.968Z",
    transform: "translate(-60 -320)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_422_",
    transform: "translate(8.903 53.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    d: "M103.033,362.968H61.484a1.484,1.484,0,1,1,0-2.968h41.549a1.484,1.484,0,1,1,0,2.968Z",
    transform: "translate(-60 -360)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_420_",
    transform: "translate(8.903 59.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    d: "M106,402.968H61.484a1.484,1.484,0,1,1,0-2.968H106a1.484,1.484,0,1,1,0,2.968Z",
    transform: "translate(-60 -400)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_418_",
    transform: "translate(8.903 65.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    d: "M114.9,442.968H61.484a1.484,1.484,0,0,1,0-2.968H114.9a1.484,1.484,0,0,1,0,2.968Z",
    transform: "translate(-60 -440)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_409_",
    transform: "translate(23.743 17.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_414_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_415_",
    d: "M173.355,146.71a13.355,13.355,0,1,1,13.355-13.355A13.37,13.37,0,0,1,173.355,146.71Zm0-23.743a10.387,10.387,0,1,0,10.387,10.387A10.4,10.4,0,0,0,173.355,122.968Z",
    transform: "translate(-160 -120)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_412_",
    transform: "translate(7.42 7.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    d: "M220.388,181.871a1.48,1.48,0,0,1-1.049-.435l-8.9-8.9a1.484,1.484,0,0,1,2.1-2.1l8.9,8.9a1.484,1.484,0,0,1-1.049,2.533Z",
    transform: "translate(-210 -169.999)",
    fill: "#ff5b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_410_",
    transform: "translate(7.42 7.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    d: "M211.484,181.871a1.484,1.484,0,0,1-1.049-2.533l8.9-8.9a1.484,1.484,0,0,1,2.1,2.1l-8.9,8.9A1.48,1.48,0,0,1,211.484,181.871Z",
    transform: "translate(-210 -169.999)",
    fill: "#ff5b00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFound);
export default __webpack_public_path__ + "static/media/no-result-found.a8c05916ed9a134b696b0fa81928ec6d.svg";
export { ForwardRef as ReactComponent };